import { formatDatetime } from "helpers/commonHelpers";
import { DateTimeFormat, getDurationInWords } from "helpers/dateTimeHelper";

type QuoteDetailRouteStopListItemProps = {
  portName?: string;
  pickupPortCode: string;
  pickupDateTime: string;
  deliveryPortCode: string;
  deliveryDateTime: string;
};

function QuoteDetailRouteStopListItem(props: QuoteDetailRouteStopListItemProps) {
  const { portName, pickupPortCode, pickupDateTime, deliveryPortCode, deliveryDateTime } = props;
  return (
    <div className="d-flex flex-column align-items-center route-detail-info-container">
      {portName && <div className="text-xs text-tertiary">{portName}</div>}
      <div className="d-flex align-items-center w-100">
        <div className="position-relative">
          <div className="text-sm font-medium font-black">{pickupPortCode || ""}</div>
          <div className="pickup-container">
            <div className="text-sm text-primary">{formatDatetime(pickupDateTime, DateTimeFormat.shortDateTimeFormat)}</div>
          </div>
        </div>
        <div className="route-detail-line" />
        <div className="position-relative">
          <div className="text-sm font-medium font-black">{deliveryPortCode || ""}</div>
          <div className="delivery-container">
            <div className="text-sm text-primary">
              {formatDatetime(deliveryDateTime, DateTimeFormat.shortDateTimeFormat)}
            </div>
          </div>
        </div>
      </div>
      <div className="text-sm text-tertiary">{getDurationInWords(pickupDateTime, deliveryDateTime)}</div>
    </div>
  );
}

export default QuoteDetailRouteStopListItem;

QuoteDetailRouteStopListItem.defaultProps = {
  portName: undefined,
};
